const buildLinkQuery = /* GraphQL */ `
  query BuildLink($linkRequest: LinkRequestInput) {
    buildLink(linkRequest: $linkRequest) {
      url
      isValid
    }
  }
`

export default buildLinkQuery
